import { CollectionEntity } from "@busy-human/gearbox";
export var Incident;
(function (Incident) {
    let FacilityDepartment;
    (function (FacilityDepartment) {
        FacilityDepartment["ER"] = "ER";
        FacilityDepartment["ICU"] = "ICU";
        FacilityDepartment["OB"] = "OB";
        FacilityDepartment["MedSurg"] = "MedSurg";
        FacilityDepartment["PedsER"] = "PEDS ER";
        FacilityDepartment["Other"] = "Other";
    })(FacilityDepartment = Incident.FacilityDepartment || (Incident.FacilityDepartment = {}));
    Incident.DepartmentsList = Object.values(FacilityDepartment);
    Incident.Complaints = ['Abdominal Pain', 'Allergic Reaction', 'Animal Bites', 'Assault', 'Back Pain', 'Breathing Difficulty', 'Burn Subject', 'Hazardous Exposure', 'Cardiac Arrest', 'Chest Pain', 'Choking', 'Seizures', 'Diabetic Problems', 'Drowning', 'Electrocution', 'Eye Problem', 'Falls', 'Headache', 'Heart Problem', 'Environmental Exposure', 'Hemmorrhage', 'Industrial Accidents', 'Overdose', 'Pregnancy', 'Psychiatric Problem', 'Sick Call', 'Stab/Gunshot/Pentrating Truama', 'Stroke', 'Traffic Collision', 'Traumatic Injuries', 'Subject Unconscious', 'Medical Nature Unkown', 'Transfer', 'Other'];
    let Gender;
    (function (Gender) {
        Gender["Male"] = "male";
        Gender["Femail"] = "femail";
    })(Gender || (Gender = {}));
    let IncidentType;
    (function (IncidentType) {
        IncidentType["InterFacility"] = "interfacility";
        IncidentType["Scene"] = "scene";
        IncidentType["Maintenance"] = "maintenance";
        IncidentType["Reposition"] = "reposition";
        IncidentType["PR"] = "pr";
    })(IncidentType = Incident.IncidentType || (Incident.IncidentType = {}));
    function Defaults() {
        return {
            number: '',
            company: '',
            type: null,
            description: '',
            weight: null,
            unitResponses: [],
            assignedUnit: null,
            turnDown: null,
            // facilityInfo:null,
            patient: null,
            receivingFacility: null,
            positionLog: [],
            ramReport: null,
            active: true,
            timeCreated: new Date().toISOString(),
            fuel: '',
            pilotETA: null,
            personsOnBoard: null,
            incidentReportPDF: null,
            onCreateETA: null,
            weather: '',
            landingZone: null,
            createdBy: null,
            airportArrival: '',
            airportDeparture: '',
            groundContact: null,
            flightTime: null
        };
    }
    Incident.Defaults = Defaults;
    class CollectionClass extends CollectionEntity {
        relationships;
        defaults() {
            return Defaults();
        }
    }
    Incident.CollectionClass = CollectionClass;
})(Incident || (Incident = {}));
//# sourceMappingURL=index.js.map